"use client";

import { ReactNode } from "react";

import { usePath } from "@/hooks/use-path";
import { MyWatchList } from "@/layouts/my-watch-list";

export const MyContent = ({ children }: { children: ReactNode }) => {
  const { isTradingViewAdvancedChartPage } = usePath();

  return (
    <div id="my-content" className="relative flex flex-grow overflow-y-auto">
      <main className="h-fit w-full transition-all @container">
        {/* sticky navbar mask */}
        {isTradingViewAdvancedChartPage ? null : (
          <div className="sticky top-0 z-20 h-[var(--my-navbar-mask-height)] shrink-0 bg-gradient-to-l from-zinc-900 to-sky-700 bg-fixed" />
        )}
        {children}
      </main>
      <MyWatchList />
    </div>
  );
};
